import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../axios';
import {
    Container, DetailsBtns, Flex,
    Form, FormBtn, FormCover,
    H1, H3,
    MediumSpacing, SmallSpacing
} from "../../styles";

const UpdateGrade = () => {
    const { id } = useParams(); // Enrollment ID
    const navigate = useNavigate();
    const [enrollment, setEnrollment] = useState(null);
    const [student, setStudent] = useState(null);
    const [classEnrolled, setClassEnrolled] = useState(null);
    const [grade, setGrade] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        axios.get(`/student_enrollment/${id}/`)
            .then(response => {
                const enrollmentData = response.data;
                setEnrollment(enrollmentData);
                setGrade(enrollmentData.grade);

                // Fetch student details
                axios.get(`/students/${enrollmentData.student}/`)
                    .then(studentResponse => {
                        setStudent(studentResponse.data);
                    })
                    .catch(error => console.error("There was an error fetching the student data!", error));

                // Fetch class details
                axios.get(`/classes/${enrollmentData.class_enrolled}/`)
                    .then(classResponse => {
                        setClassEnrolled(classResponse.data);
                    })
                    .catch(error => console.error("There was an error fetching the class data!", error));
            })
            .catch(error => console.error("There was an error fetching the enrollment data!", error));
    }, [id]);

    const handleSave = (event) => {
        event.preventDefault();
        setErrorMessage('');
        axios.patch(`/student_enrollment/${id}/`, {
            grade: grade
        })
            .then(response => {
                navigate(`/class/${enrollment.class_enrolled}`);
            })
            .catch(error => {
                console.error("There was an error updating the grade!", error);
                setErrorMessage("There was an error updating the grade!");
            });
    };

    const handleSaveAndSend = (event) => {
        event.preventDefault();
        setErrorMessage('');
        axios.post(`/student_enrollment/${id}/update_grade_and_send_email/`, {
            grade: grade
        })
            .then(response => {
                navigate(`/class/${enrollment.class_enrolled}`);
            })
            .catch(error => {
                console.error("There was an error updating the grade and sending the email!", error);
                setErrorMessage("There was an error updating the grade and sending the email!");
            });
    };

    if (!enrollment || !student || !classEnrolled) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <FormCover>
            <H3>Update Grade</H3>
            <MediumSpacing />
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                <Form>
                    <p>Student ID: {student.student_id}</p>
                    <p>Student Name: {student.first_name} {student.last_name}</p>
                    <p>Class: {classEnrolled.course_details.name} - {classEnrolled.number}</p>
                    <label>
                        Grade:
                    </label>
                    <br/>
                    <input type="text" value={grade} onChange={(e) => setGrade(e.target.value)} required/>
                <MediumSpacing/>
                    <Flex>
                        <button type="button" onClick={handleSave}>Save</button>
                                        <SmallSpacing/>

                        <button type="button" onClick={handleSaveAndSend}>Save and Send</button>
                                                                <SmallSpacing/>

                        <button type="button" onClick={() => navigate(-1)}>Close</button>
                    </Flex>
                </Form>
            </FormCover>
        </Container>
    );
};

export default UpdateGrade;
